// Random name generator for quiz participants
// Generates fun names like "Swift Tiger" or "Cosmic Phoenix"

const adjectives = [
  'Swift', 'Brave', 'Clever', 'Silent', 'Golden', 'Cosmic', 'Mystic',
  'Turbo', 'Ninja', 'Super', 'Mega', 'Ultra', 'Cyber', 'Pixel',
  'Quantum', 'Thunder', 'Lightning', 'Crystal', 'Shadow', 'Fire',
  'Ice', 'Storm', 'Stellar', 'Neon', 'Atomic', 'Electric', 'Frozen',
  'Blazing', 'Mighty', 'Noble', 'Royal', 'Secret', 'Wild', 'Wise',
  'Zen', 'Epic', 'Lucky', 'Magic', 'Power', 'Rapid', 'Sonic',
  'Stealth', 'Hyper', 'Astral', 'Digital', 'Galactic', 'Phantom',
  'Primal', 'Savage', 'Bright', 'Dark', 'Quick', 'Smart', 'Cool'
];

const animals = [
  'Tiger', 'Eagle', 'Falcon', 'Wolf', 'Phoenix', 'Dragon', 'Panther',
  'Shark', 'Hawk', 'Fox', 'Bear', 'Lion', 'Cobra', 'Raven', 'Owl',
  'Dolphin', 'Cheetah', 'Lynx', 'Jaguar', 'Viper', 'Panda', 'Koala',
  'Orca', 'Condor', 'Gorilla', 'Leopard', 'Raptor', 'Stag', 'Mongoose',
  'Badger', 'Otter', 'Husky', 'Cougar', 'Coyote', 'Bobcat', 'Wolverine',
  'Mantis', 'Hornet', 'Spider', 'Scorpion', 'Python', 'Kraken', 'Griffin',
  'Hydra', 'Pegasus', 'Sphinx', 'Unicorn', 'Yeti', 'Turtle', 'Rabbit'
];

/**
 * Generate a random fun name
 * @returns {string} A name like "Swift Tiger"
 */
export function generateRandomName() {
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const animal = animals[Math.floor(Math.random() * animals.length)];
  return `${adjective} ${animal}`;
}

/**
 * Generate a unique participant ID
 * @returns {string} A unique ID like "user-x7k9m2"
 */
export function generateParticipantId() {
  return `user-${Math.random().toString(36).substring(2, 10)}`;
}

export default generateRandomName;
